var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"query-name",on:{"click":_vm.updateIsChecked}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"select":_vm.updateIsChecked}}),_c('QueryText',{attrs:{"query":_vm.query}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }